module.exports = __webpack_public_path__ + "img/cimb.fa629525.png";